/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Information about the time zone associated with the start and end timestamps.
 */
export type PeriodDtoTimeZone = typeof PeriodDtoTimeZone[keyof typeof PeriodDtoTimeZone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeriodDtoTimeZone = {
  BRUSSELS: 'BRUSSELS',
  LONDON: 'LONDON',
  NEW_YORK: 'NEW_YORK',
} as const;
